import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css'],
    standalone: false
})
export class ReportsComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;

  total_services_fees: number = 0;

  token: any;
  report: any;
  month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  year: any;
  total_appointment_payment = 0;
  package_appointment_payment = 0;

  staffs: any[] = [];

  report_date = new Date();

  constructor(public utility: UtilitiesService, private modalService: NgbModal, public api: ApiService, private router: Router) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    let date = new Date();
    this.year = date.getFullYear();

    this.getStaffs()
  }

  getStaffs() {
    this.utility.loading = true;
    const sub = this.api.get('employees/active', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.staffs = objects;

        this.staffs.filter(i => i.name != 'Amal');
      },
      async error => { }
    );
    sub.add(() => { this.getReport(); });
  }

  getReport() {
    const sub = this.api.get('appointments/report', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.report = objects;

        if (this.report?.appointments_this_month_service) {
          this.total_services_fees = this.report.appointments_this_month_service.reduce(
            (sum: any, s: any) => +sum + (+s.services_total_fees || 0),
            0
          );
        }

        let recommandded_by: any[];
        recommandded_by = this.report.appointments_this_month_recommanded_by;
        this.report.recommandded_by_total = 0;

        recommandded_by.forEach((element) => {
          this.report.recommandded_by_total += element.appointments_count;
        })

        let services: any[];
        services = this.report.appointments_this_month;

        this.report.medical_reports = services.filter(i => i.service_name === 'Medical Report');
        this.report.medical_reports_fees = 0;

        if (this.report.medical_reports)
          this.report.medical_reports.forEach((element: any) => {
            this.report.medical_reports_fees += element.total_fees;
          });
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  getTotals(type: any) {
    if (type == 'G') {
      const total_patients: any[] = this.report?.number_of_patients ?? [];
      return total_patients.reduce((sum, item) => sum + (item.patients_count ?? 0), 0);
    }
    return 0;
  }

  getByStaff(name: any, type: any, service_name?: any) {
    if (type == 'G') {
      let total_patients: any[] = this.report?.number_of_patients;
      let restult = total_patients ? total_patients.find(i => i.employee === name) : null;
      return restult ? restult.patients_count : 0;
    }
    if (type == 'A') {
      let new_patients: any[] = this.report?.new_patients;
      let restult = new_patients ? new_patients.find(i => i.doctor_name === name) : null;
      return restult ? restult.new_patients_count : 0;
    }
    if (type == 'B') {
      const medical_reports: any[] = this.report?.medical_reports ?? [];
      return medical_reports.filter(i => i.doctor_name === name).length;
    }
    if (type == 'C') {
      const appointments_this_month: any[] = this.report?.appointments_this_month ?? [];
      const restult = appointments_this_month.find(i => i.doctor_name === name && i.service_name == service_name);
      return restult?.total_fees ?? 0;
    }
    if (type == 'D') {
      const appointments_this_month_recommanded_by: any[] = this.report?.appointments_this_month_recommanded_by ?? [];
      const restult = appointments_this_month_recommanded_by.find(i => i.employee === name);
      return restult?.appointments_count ?? 0;
    }
    if (type == 'F') {
      let services: any[] = this.report?.appointments_this_month;
      let restult = services ? services.find(i => i.doctor_name === name && i.service_name === 'Medical Report') : null;
      return restult ? restult?.total_fees : 0;
    }
    if (type == 'E') {
      let services: any[] = this.report?.working_hours;
      let restult = services ? services.find(i => i.employee === name) : null;
      return restult ? restult?.appointments_count : 0;
    }
    return 0;
  }

  getBonus(amount: any, appointments: number, salary: number) {
    let BF = 0;
    appointments = appointments / 30;

    if (appointments > 15 && appointments < 20)
      BF = 1.1;
    if (appointments == 20)
      BF = 1.2;
    if (appointments > 20 && appointments < 25)
      BF = 1.3;
    if (appointments == 25)
      BF = 1.4;
    if (appointments > 25)
      BF = 1.5;

    return salary * BF;
  }

  getReportSpecific() {
    let date = new Date(this.report_date);
    this.utility.loading = true;
    const sub = this.api.get(`appointments/report/${(date.getMonth() + 1)}/${date.getFullYear()}`, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.report = objects;

        if (this.report?.appointments_this_month_service) {
          this.total_services_fees = this.report.appointments_this_month_service.reduce(
            (sum: any, s: any) => +sum + (+s.services_total_fees || 0),
            0
          );
        }

        let recommandded_by: any[];
        recommandded_by = this.report.appointments_this_month_recommanded_by;
        this.report.recommandded_by_total = 0;

        recommandded_by.forEach((element) => {
          this.report.recommandded_by_total += element.appointments_count;
        })

        let services: any[];
        services = this.report.appointments_this_month;

        this.report.medical_reports = services.filter(i => i.service_name === 'Medical Report');
        this.report.medical_reports_fees = 0;

        if (this.report.medical_reports)
          this.report.medical_reports.forEach((element: any) => {
            this.report.medical_reports_fees += element.total_fees;
          });
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }
}
